module.exports = __webpack_public_path__ + "static/media/Fullscreen-On.1d919f53.svg";